import { FC } from 'react';
import { OpenInNew } from '@mui/icons-material';
import { Button, Tooltip, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Row, Column } from 'further-ui/components/Layout';
import React from 'react';

const Shell = styled(Row)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: 12,
  border: `1px solid ${theme.palette.divider}`,
  padding: theme.spacing(3, 4),
}));

const Content = styled('div')({
  flex: 1,
  minWidth: 0,
});

const IconButton = styled(Button)(({ theme }) => ({
  paddingLeft: theme.spacing(0),
  paddingRight: theme.spacing(0),
  minWidth: '32px',
}));

const LabelSuffix = styled(`span`)(({ theme }) => ({
  color: theme.palette.grey[500],
}));

type Props = {
  icon: React.ReactNode;
  label: string;
  description?: string;
  primaryAction?: { label: string; onClick: () => void };
  openInNewHref?: string;
};

const TaskPrompt: FC<Props> = ({
  icon,
  label,
  description,
  primaryAction,
  openInNewHref,
}) => (
  <Shell centered spacing="xs" justify="space-between">
    <Column spacing="xs">
      <Row centered spacing="xs">
        {icon}
        <Content>
          <Typography variant="h6" noWrap>
            {label.includes(' / ') ? (
              <>
                {label.substring(0, label.indexOf(' / '))}
                <LabelSuffix>
                  {label.substring(label.indexOf(' / '))}
                </LabelSuffix>
              </>
            ) : (
              label
            )}
          </Typography>
        </Content>
      </Row>

      {description && (
        <Row centered spacing="xs">
          <Typography variant="caption" color="text.secondary">
            {description}
          </Typography>
        </Row>
      )}
    </Column>
    {(primaryAction || openInNewHref) && (
      <Row centered spacing="xs">
        {primaryAction && (
          <Button
            variant="outlined"
            size="large"
            onClick={primaryAction.onClick}
          >
            {primaryAction.label}
          </Button>
        )}
        {openInNewHref && (
          <Tooltip title="Open in new tab">
            <IconButton
              size="large"
              variant="outlined"
              onClick={() => window.open(openInNewHref, '_blank')}
            >
              <OpenInNew sx={{ fontSize: 16 }} />
            </IconButton>
          </Tooltip>
        )}
      </Row>
    )}
  </Shell>
);

export default TaskPrompt;
